// extracted by mini-css-extract-plugin
export default {"spaced2Row":"editor_spaced2Row__U1w+G","switchRow":"editor_switchRow__D+ahE","checkedRow":"editor_checkedRow__+D5k3"};